export var IndexKind;
(function (IndexKind) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/echo/indexing.proto}
     */
    let Kind;
    (function (Kind) {
        Kind[Kind["SCHEMA_MATCH"] = 0] = "SCHEMA_MATCH";
        Kind[Kind["FIELD_MATCH"] = 1] = "FIELD_MATCH";
        Kind[Kind["FULL_TEXT"] = 2] = "FULL_TEXT";
        Kind[Kind["VECTOR"] = 3] = "VECTOR";
        Kind[Kind["GRAPH"] = 4] = "GRAPH";
    })(Kind = IndexKind.Kind || (IndexKind.Kind = {}));
})(IndexKind || (IndexKind = {}));
//# sourceMappingURL=indexing.js.map